import { render } from "./FootBar.vue?vue&type=template&id=2f679c4d&scoped=true"
import script from "./FootBar.vue?vue&type=script&lang=js"
export * from "./FootBar.vue?vue&type=script&lang=js"

import "./FootBar.vue?vue&type=style&index=0&id=2f679c4d&scoped=true&lang=css"

import exportComponent from "F:\\XAMPP_NEW\\htdocs\\ASRHAVELI\\delivery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f679c4d"]])

export default __exports__